export default "__VITE_ASSET__semfkDw0__"